import React from 'react';
import { syncProducts, resyncProducts, syncProduct, saveProducts, resaveProducts, saveMetadata, syncProductMetafields, syncProductVariantMetafields, syncProductImages, createProductCustomContents, deleteProductCustomContent, exportProducts, importProducts, exportProductMetafields, importProductMetafields, clearExportUrls, resetErrors, getProductOptionValuesPaginated } from '../../modules/products'
import withRouter from 'with-router'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import ItemsList from '../../components/ItemsList'
import ItemsListSkeleton from '../../components/ItemsListSkeleton'
import LoadingIndicator from '../../components/LoadingIndicator';
import Button from '@mui/material/Button';
import EmptyView from '../../components/EmptyView';
//import BulkTranslations from '../../components/BulkTranslations';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Link from '@mui/material/Link';
import OptionsMenu from '../../components/OptionsMenu';
import NewFlexItemList from '../../components/NewFlexItemList';
import cloneDeep from 'lodash/cloneDeep';
import API from '../../api/api.js';
import { Trans, withTranslation, useTranslation } from 'react-i18next';
import ExportImportDialogs from '../../components/ExportImportDialogs';
import SolutionsArticleLink from '../../components/SolutionsArticleLink';
import { t as translate } from 'i18next';
import { _clearUnchangedFields } from '../../helper';


// the Tags/Types/Vendors rows are plain data, so the header link is built here
const typesArticleLink = () => <SolutionsArticleLink
  article="productTypes"
  subject={translate('pages.products.productTypes')}
  placement="rowHeader"
/>;

class Products extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      products: [],
      metadata: [
      {
        id: 'tags',
        synchronized: false,
        title: 'Tags',
        info: '',
        fields: []
      },{
        id: 'types',
        synchronized: false,
        title: 'Types',
        info: '',
        headerAdornment: typesArticleLink(),
        fields: []
      },{
        id: 'vendors',
        synchronized: false,
        title: 'Vendors',
        info: '',
        fields: []
      }
      ],
      addingNewCustomContent: false,
      addingNewCustomContentProductId: null,
      customContentPlainTextData: [],
      forceOpenExportDialog: false,
      forceOpenImportDialog: false,
      showDownloadDialog: false,
      showImportCompleteDialog: false,
      showBulkDialog: false,
      errorLockCollapse: false,
    }
  }

  componentDidMount() {
    this.props.syncProducts(this.props.editLanguage)
    if(this.props.products.export_po_download_url || this.props.products.export_csv_download_url) {
      this.setState({showDownloadDialog: false})
    }
  }

  componentWillUnmount() {
    API.stopBulkOperationPolling();
    API.clearAllFetches();
  }

  getErrorsFor(key, item) {
    if (typeof item.errors === 'undefined') return false;
    let error = item.errors.find(x => x.object_key === key);
    return error;
  }

  componentWillReceiveProps(newProps) {
    const { t } = this.props;
    const currentLanguage = this.props.editLanguage;
    const newLanguage = newProps.editLanguage;
    if(currentLanguage != newLanguage) {
      this.props.syncProducts(newLanguage)
      return
    }

    if(this.props.products.import_products_pending === true && newProps.products.import_products_pending === false && !newProps.products.error && !newProps.products.import_cancelled) {
      this.setState({showImportCompleteDialog: true}, () => {
        this.setState({showImportCompleteDialog: false});
      })
    }

    if((this.props.products.sync_products_pending === true && newProps.products.sync_products_pending === false)
    || (this.props.products.sync_product_pending === true && newProps.products.sync_product_pending === false)
    || (this.props.products.save_products_pending === true && newProps.products.save_products_pending === false)
    || (this.props.products.save_metadata_pending === true && newProps.products.save_metadata_pending === false)
    || (this.props.products.get_option_values_page_pending === true && newProps.products.get_option_values_page_pending === false)
    ) {
      const newProducts = [];

      newProps.products.products.forEach((item) => {
        let optionFields = []
        if(item.options) {
          item.options.forEach((option, index) => {
            //if(index > (item.optionsCurrentPage -1)*100 && index < (item.optionsCurrentPage -1)*100+100) {
              if(option !== null) {
                if(option.source !== 'Default Title') {
                  optionFields.push({
                    id: option.source,
                    type: 'text',
                    source: option.source,
                    target: option.target || '',
                    gid: option.gid,
                    key: option.key
                  })
                }
              }
            //}
          })

          //console.log(optionFields)
        }

        let optionNameFields = []
        if(item.optionNames) {
          item.optionNames.forEach((optionName) => {
            if(optionName.source !== 'Title') {
              optionNameFields.push({
                id: optionName.id,
                type: 'text',
                source: optionName.source,
                target: optionName.target || ''
              })
            }
          })
        }

        let customFields = []
        if(item.custom_contents) {
          item.custom_contents.forEach(custom_content => {
            customFields.push({
              id: custom_content.id,
              type: 'text',
              deletable: true,
              multiline: true,
              rows: 7,
              source: custom_content.source.text,
              target: custom_content.target.text
            })
          })
        }

        let seoFields = []

        if(typeof item.target.page_title !== 'undefined') {
          seoFields.push({
            id: 'page_title',
            type: 'text',
            label: 'SEO Title',
            source: item.source.page_title || '',
            target: item.target.page_title || '',
            maxLength: 255,
            customized: item.customSeo.meta_title
          })
        }

        if(typeof item.target.page_description !== 'undefined') {
          seoFields.push({
            multiline: true,
            rows: 6,
            id: 'page_description',
            type: 'text',
            label: 'SEO Description',
            source: item.source.page_description || '',
            target: item.target.page_description || '',
            maxLength: 500,
            customized: item.customSeo.meta_description
          })
        }

        const usedFields = [
            {
              id: 'title',
              type: 'text',
              label: 'Title',
              source: item.source.title,
              target: item.target.title || ''
            },
            {
              multiline: true,
              rows: 10,
              id: 'body_html',
              type: 'richtext',
              label: 'Description',
              source: item.source.body_html || '',
              target: item.target.body_html || '',
            },
            {
              id: 'product_type',
              type: 'text',
              label: 'Product Type',
              source: item.source.product_type,
              target: item.target.product_type || '',
              errors: this.getErrorsFor('product_type', item) || false,
              maxLength: 255,
            },
            {
              id: 'handle',
              type: 'text',
              label: 'Handle',
              source: item.source.handle,
              target: item.target.handle || '',
              errors: this.getErrorsFor('handle', item) || false
            },
            {
              id: 'seofields',
              type: 'subfields',
              fields: seoFields
            }
        ]

        let currentMetafields = null;
        let currentVariantMetafields = null;
        let currentImagefields = null;
        if(!(this.props.products.sync_products_pending === true && newProps.products.sync_products_pending === false)) {
          const currentProduct = this.state.products.find(x => x.id == item.id);
          if(currentProduct) {
            currentMetafields = currentProduct.fields.find(x => x.id === 'metafields');
            currentVariantMetafields = currentProduct.fields.find(x => x.id === 'variant_metafields');
            currentImagefields = currentProduct.fields.find(x => x.id === 'images');
          }
        }

        usedFields.push({
            id: 'images',
            type: 'subfields',
            fields: currentImagefields ? cloneDeep(currentImagefields.fields) : []
        })

        usedFields.push({
            id: 'option_names',
            type: 'subfields',
            fields: optionNameFields
        })

        usedFields.push({
            id: 'metafields',
            type: 'subfields',
            fields: currentMetafields ? cloneDeep(currentMetafields.fields) : []
        })

        usedFields.push({
            id: 'variants',
            type: 'subfields',
            fields: optionFields,
            paginated: true,
            totalCount: item.optionsTotal,
            currentPage: item.optionsCurrentPage,
        })

        usedFields.push({
            id: 'variant_metafields',
            type: 'subfields',
            fields: currentVariantMetafields ? cloneDeep(currentVariantMetafields.fields) : []
        })

        usedFields.push({
            id: 'customfields',
            onAddItem: this.openNewCustomContentDialog,
            onDeleteItem: this.onDeleteCustomContent(item.id),
            emptyMessage: <EmptyView
              title={t('customContents.noCustomContentInSection')}
              description={t('customContents.info1')}
              bottom={<Button variant="outlined" size="small" onClick={e => {this.openNewCustomContentDialog(item.id)}}>{t('customContents.addNewCustomContent')}</Button>}
              dense={true}
            />,
            type: 'subfields',
            fields: customFields
        })

        newProducts.push({
          type: 'product',
          id: item.id,
          shopify_id: item.shopifyId,
          progress: item.progress,
          synchronized: item.synchronized,
          title: item.source.title,
          metafields_synchronized: item.metafields_synchronized,
          images_synchronized: item.images_synchronized,
          fields: usedFields
        })
      });

      const tagFields = []
      let translatedTags = 0;
      let tagsProgress = 0

      const typeFields = []
      let translatedTypes = 0;
      let typesProgress = 0

      const vendorFields = []
      let translatedVendors = 0;
      let vendorsProgress = 0

      for(let key in newProps.products.tags) {
        const item = newProps.products.tags[key];
        if(item.target) {
          translatedTags++;
        }
        tagFields.push({
                multiline: true,
                rows: 4,
                id: item.id,
                type: 'text',
                source: item.source,
                target: item.target || '',
                vitualized: true,
        })
      }
      if(tagFields.length > 0) {
        tagsProgress = Math.floor(translatedTags / tagFields.length * 100);
        if(tagsProgress > 100) {
          tagsProgress = 100;
        }
      } else {
        tagsProgress = 100;
      }

      for(let key in newProps.products.types) {
        const item = newProps.products.types[key];
        if(item.target) {
          translatedTypes++;
        }
        typeFields.push({
                multiline: true,
                rows: 4,
                id: item.id,
                type: 'text',
                source: item.source,
                target: item.target || '',
                vitualized: true,
        })
      }
      if(typeFields.length > 0) {
        typesProgress = Math.floor(translatedTypes / typeFields.length * 100);
        if(typesProgress > 100) {
          typesProgress = 100;
        }
      } else {
        typesProgress = 100;
      }

      for(let key in newProps.products.vendors) {
        const item = newProps.products.vendors[key];

        //console.log(key)

        if(item.target) {
          translatedVendors++;
        }
        vendorFields.push({
                multiline: true,
                rows: 4,
                id: item.id,
                type: 'text',
                source: item.source,
                target: item.target || '',
                vitualized: true,
        })
      }
      if(vendorFields.length > 0) {
        vendorsProgress = Math.floor(translatedVendors / vendorFields.length * 100);
        if(vendorsProgress > 100) {
          vendorsProgress = 100;
        }
      } else {
        vendorsProgress = 100;
      }

      const newMetadata = [
        {
          id: 'tags',
          progress: tagsProgress,
          synchronized: true,
          title: 'Tags',
          info: '',
          fields: tagFields
        },{
          id: 'types',
          progress: typesProgress,
          synchronized: true,
          title: 'Types',
          info: '',
          headerAdornment: typesArticleLink(),
          fields: typeFields
        },{
          id: 'vendors',
          progress: vendorsProgress,
          synchronized: true,
          title: 'Vendors',
          info: '',
          fields: vendorFields
        }
      ]

      this.setState({
        products:newProducts,
        metadata:newMetadata
      });
    }

    // Progressive batch: new products arrived while sync still pending
    if(
      this.props.products.sync_products_pending === true &&
      newProps.products.sync_products_pending === true &&
      newProps.products.products.length > this.props.products.products.length
    ) {
      const batchItems = newProps.products.products.slice(this.props.products.products.length);
      const batchProducts = [];

      batchItems.forEach((item) => {
        let optionFields = []
        if(item.options) {
          item.options.forEach((option) => {
            if(option !== null && option.source !== 'Default Title') {
              optionFields.push({
                id: option.source,
                type: 'text',
                source: option.source,
                target: option.target || '',
                gid: option.gid,
                key: option.key
              })
            }
          })
        }

        let optionNameFields = []
        if(item.optionNames) {
          item.optionNames.forEach((optionName) => {
            if(optionName.source !== 'Title') {
              optionNameFields.push({
                id: optionName.id,
                type: 'text',
                source: optionName.source,
                target: optionName.target || ''
              })
            }
          })
        }

        let customFields = []
        if(item.custom_contents) {
          item.custom_contents.forEach(custom_content => {
            customFields.push({
              id: custom_content.id,
              type: 'text',
              deletable: true,
              multiline: true,
              rows: 7,
              source: custom_content.source.text,
              target: custom_content.target.text
            })
          })
        }

        let seoFields = []
        if(typeof item.target.page_title !== 'undefined') {
          seoFields.push({ id: 'page_title', type: 'text', label: 'SEO Title', source: item.source.page_title || '', target: item.target.page_title || '', maxLength: 255, customized: item.customSeo.meta_title })
        }
        if(typeof item.target.page_description !== 'undefined') {
          seoFields.push({ multiline: true, rows: 6, id: 'page_description', type: 'text', label: 'SEO Description', source: item.source.page_description || '', target: item.target.page_description || '', maxLength: 500, customized: item.customSeo.meta_description })
        }

        const usedFields = [
          { id: 'title', type: 'text', label: 'Title', source: item.source.title, target: item.target.title || '' },
          { multiline: true, rows: 10, id: 'body_html', type: 'richtext', label: 'Description', source: item.source.body_html || '', target: item.target.body_html || '' },
          { id: 'product_type', type: 'text', label: 'Product Type', source: item.source.product_type, target: item.target.product_type || '', errors: this.getErrorsFor('product_type', item) || false, maxLength: 255 },
          { id: 'handle', type: 'text', label: 'Handle', source: item.source.handle, target: item.target.handle || '', errors: this.getErrorsFor('handle', item) || false },
          { id: 'seofields', type: 'subfields', fields: seoFields }
        ]
        usedFields.push({ id: 'images', type: 'subfields', fields: [] })
        usedFields.push({ id: 'option_names', type: 'subfields', fields: optionNameFields })
        usedFields.push({ id: 'metafields', type: 'subfields', fields: [] })
        usedFields.push({ id: 'variants', type: 'subfields', fields: optionFields, paginated: true, totalCount: item.optionsTotal, currentPage: item.optionsCurrentPage })
        usedFields.push({ id: 'variant_metafields', type: 'subfields', fields: [] })
        usedFields.push({
          id: 'customfields',
          onAddItem: this.openNewCustomContentDialog,
          onDeleteItem: this.onDeleteCustomContent(item.id),
          emptyMessage: <EmptyView
            title={t('customContents.noCustomContentInSection')}
            description={t('customContents.info1')}
            bottom={<Button variant="outlined" size="small" onClick={() => {this.openNewCustomContentDialog(item.id)}}>{t('customContents.addNewCustomContent')}</Button>}
            dense={true}
          />,
          type: 'subfields',
          fields: customFields
        })

        batchProducts.push({
          type: 'product',
          id: item.id,
          shopify_id: item.shopifyId,
          progress: item.progress,
          synchronized: item.synchronized,
          title: item.source.title,
          metafields_synchronized: item.metafields_synchronized,
          images_synchronized: item.images_synchronized,
          fields: usedFields
        })
      });

      this.setState(prevState => ({
        products: [...prevState.products, ...batchProducts]
      }));
    }

    // METAFIELDS
    if(this.props.products.sync_product_metafields_pending === true && newProps.products.sync_product_metafields_pending === false) {
      let newProducts = cloneDeep(this.state.products);
      newProps.products.products.forEach(product => {
        if(product.metafields) {
            let productToUpdate = newProducts.find(x => x.id == product.id)

            let newMetafields = []
            product.metafields.forEach(metafield => {
              const currentField = productToUpdate.fields.find(x => x.id === 'metafields').fields.find(x => x.id == metafield.id);
              if(!currentField) {
                newMetafields.push({
                  id: metafield.id,
                  type: 'text',
                  multiline: true,
                  rows: 7,
                  source: metafield.source,
                  target: metafield.target || '',
                  label: metafield.namespace + ' -> ' + metafield.key
                })
              } else {
                if(product.metafields.find(x => x.id === currentField.id)) {
                  newMetafields.push({...currentField});
                }
              }
            })

            productToUpdate.metafields_synchronized = product.metafields_synchronized
            productToUpdate.fields.find(x => x.id === 'metafields').fields = newMetafields
        }
      })

      this.setState({products:newProducts});
    }

    // VARIANT METAFIELDS
    if(this.props.products.sync_product_variant_metafields_pending === true && newProps.products.sync_product_variant_metafields_pending === false) {
      let newProducts = cloneDeep(this.state.products);
      newProps.products.products.forEach(product => {
        if(product.variant_metafields) {
            let productToUpdate = newProducts.find(x => x.id == product.id)

            let newMetafields = []
            product.variant_metafields.forEach(metafield => {
              const currentField = productToUpdate.fields.find(x => x.id === 'variant_metafields').fields.find(x => x.id == metafield.id);
              if(!currentField) {
                newMetafields.push({
                  id: metafield.id,
                  type: 'text',
                  multiline: true,
                  rows: 7,
                  source: metafield.source,
                  target: metafield.target || '',
                  label: metafield.namespace + ' -> ' + metafield.key
                })
              } else {
                if(product.variant_metafields.find(x => x.id === currentField.id)) {
                  newMetafields.push({...currentField});
                }
              }
            })

            productToUpdate.variant_metafields_synchronized = product.variant_metafields_synchronized
            productToUpdate.fields.find(x => x.id === 'variant_metafields').fields = newMetafields
        }
      })

      this.setState({products:newProducts});
    }

    // IMAGES
    if(this.props.products.sync_product_images_pending === true && newProps.products.sync_product_images_pending === false) {
      let newProductsToUpdate = this.state.products;
      newProps.products.products.forEach(product => {
        if(product.images) {
            let productToUpdate = newProductsToUpdate.find(x => x.id == product.id)
            let newImages = []

            product.images.forEach(image => {
              const currentField = productToUpdate.fields.find(x => x.id === 'images').fields.find(x => x.id == image.id);

              const hasAlt = !!(image.media_image && image.media_image.source && image.media_image.source.alt);

              if(!currentField) {
                newImages.push({
                  id: image.id,
                  type: 'image',
                  mediaGid: image.shopify_media_id,
                  hasAlt: hasAlt,
                  source: image.source.src,
                  target: image.target.src
                })
              } else {
                if(product.images.find(x => x.id === currentField.id)) {
                  newImages.push({
                    id: currentField.id,
                    type: 'image',
                    mediaGid: image.shopify_media_id,
                    hasAlt: hasAlt,
                    source: currentField.source,
                    target: image.target.src
                  })
                }
              }

              // the image's alt text rides along as a paired text field right below its image row
              // (only when the source image has an alt - nothing to translate otherwise)
              if(hasAlt) {
                newImages.push({
                  id: `alt-${image.id}`,
                  imageId: image.id,
                  type: 'text',
                  multiline: true,
                  autoGrow: true,
                  maxLength: 512,
                  label: this.props.t('imageField.altLabel'),
                  source: image.media_image.source.alt,
                  target: (image.media_image.target && image.media_image.target.alt) ? image.media_image.target.alt : ''
                })
              }
            });

            productToUpdate.images_synchronized = product.images_synchronized;
            productToUpdate.fields.find(x => x.id === 'images').fields = newImages;
        }
      })

      this.setState({products:newProductsToUpdate});
    }

    // CUSTOM CONTENT
    if((this.props.products.create_product_custom_contents_pending === true && newProps.products.create_product_custom_contents_pending === false) || (this.props.products.delete_product_custom_content_pending === true && newProps.products.delete_product_custom_content_pending === false)) {
      let newProducts = cloneDeep(this.state.products);
      newProps.products.products.forEach(product => {
        if(product.custom_contents) {
          let productToUpdate = newProducts.find(x => x.id == product.id)

          let newCustomContents = []
          product.custom_contents.forEach(custom_content => {
            const currentField = productToUpdate.fields.find(x => x.id === 'customfields').fields.find(x => x.id == custom_content.id);
            if(!currentField) {
              newCustomContents.push({
                id: custom_content.id,
                type: 'text',
                deletable: true,
                multiline: true,
                rows: 7,
                source: custom_content.source.text,
                target: custom_content.target.text
              })
            } else {
              if(product.custom_contents.find(x => x.id === currentField.id)) {
                newCustomContents.push({...currentField});
              }
            }
          })

          productToUpdate.fields.find(x => x.id === 'customfields').fields = newCustomContents
        }
      })

      this.setState({products:newProducts});
    }
  }

  onExpandProduct(id) {
    if(this.state.products.find(x => x.id == id).synchronized !== true) {
      this.props.syncProduct(id, this.props.editLanguage);
    }
  }

  onCollapsedProduct(id) {
    
  }

  onSaveProduct = (items, selectedFields, pinnedLanguage) => {
    const usedItems = [];
    items.forEach(item => {
      if(this.props.shop_version > 2) {
        usedItems.push({
          id: item.id,
          title: item.fields.find(x => x.id === 'title').target,
          body_html: item.fields.find(x => x.id === 'body_html').target,
          product_type: item.fields.find(x => x.id === 'product_type').target,
          handle: item.fields.find(x => x.id === 'handle').source == item.fields.find(x => x.id === 'handle').target ? '' : item.fields.find(x => x.id === 'handle').target,
          page_title: item.fields.find(x => x.id === 'seofields').fields.find(x => x.id === 'page_title').target,
          page_description: item.fields.find(x => x.id === 'seofields').fields.find(x => x.id === 'page_description').target,
          options: item.fields.filter(x => (x.type === 'subfields' && x.id === 'variants'))[0].fields.map(z => ({ source: z.source, target: z.target, gid: z.gid, key: z.key })),
          option_names: item.fields.filter(x => (x.type === 'subfields' && x.id === 'option_names'))[0].fields.map(z => ({ id: z.id, target: z.target })),
          metafields: item.fields.filter(x => (x.type === 'subfields' && x.id === 'metafields'))[0].fields.map(z => ({ id: z.id, target: z.target })),
          variant_metafields: item.fields.filter(x => (x.type === 'subfields' && x.id === 'variant_metafields'))[0].fields.map(z => ({ id: z.id, target: z.target })),
          images: item.fields.filter(x => (x.type === 'subfields' && x.id === 'images'))[0].fields.filter(z => z.type === 'image').map(z => ({ id: z.id, target: z.target })),
          media_images: item.fields.filter(x => (x.type === 'subfields' && x.id === 'images'))[0].fields.filter(z => z.imageId).map(z => ({ id: z.imageId, alt: z.target || '' })),
          custom_contents: item.fields.filter(x => (x.type === 'subfields' && x.id === 'customfields'))[0].fields.map(z => ({ id: z.id, target: z.target })),
        });
      } else {
        usedItems.push({
          id: item.id,
          title: item.fields.find(x => x.id === 'title').target,
          body_html: item.fields.find(x => x.id === 'body_html').target,
          options: item.fields.filter(x => (x.type === 'subfields' && x.id === 'variants'))[0].fields.map(z => ({ source: z.source, target: z.target, gid: z.gid, key: z.key })),
          metafields: item.fields.filter(x => (x.type === 'subfields' && x.id === 'metafields'))[0].fields.map(z => ({ source: z.source, target: z.target })),
          images: item.fields.filter(x => (x.type === 'subfields' && x.id === 'images'))[0].fields.filter(z => z.type === 'image').map(z => ({ source: z.source, target: z.target })),
          media_images: item.fields.filter(x => (x.type === 'subfields' && x.id === 'images'))[0].fields.filter(z => z.imageId).map(z => ({ id: z.imageId, alt: z.target || '' })),
        });
      }
    })

    this.props.saveProducts(pinnedLanguage || this.props.editLanguage, usedItems)
  }

  onResaveAllProduct = (itemId) => {
    const item = this.state.products.find(x => x.id == itemId);
    if(item) {
      const usedItems = [{
          id: item.id,
          title: item.fields.find(x => x.id === 'title').target,
          body_html: item.fields.find(x => x.id === 'body_html').target,
          page_title: item.fields.find(x => x.id === 'seofields').fields.find(x => x.id === 'page_title').target,
          page_description: item.fields.find(x => x.id === 'seofields').fields.find(x => x.id === 'page_description').target,
          options: item.fields.filter(x => (x.type === 'subfields' && x.id === 'variants'))[0].fields.map(z => ({ source: z.source, target: z.target, gid: z.gid, key: z.key })),
          option_names: item.fields.filter(x => (x.type === 'subfields' && x.id === 'option_names'))[0].fields.map(z => ({ id: z.id, target: z.target })),
          metafields: item.fields.filter(x => (x.type === 'subfields' && x.id === 'metafields'))[0].fields.map(z => ({ id: z.id, target: z.target })),
          variant_metafields: item.fields.filter(x => (x.type === 'subfields' && x.id === 'variant_metafields'))[0].fields.map(z => ({ id: z.id, target: z.target })),
          images: item.fields.filter(x => (x.type === 'subfields' && x.id === 'images'))[0].fields.filter(z => z.type === 'image').map(z => ({ id: z.id, target: z.target })),
          media_images: item.fields.filter(x => (x.type === 'subfields' && x.id === 'images'))[0].fields.filter(z => z.imageId).map(z => ({ id: z.imageId, alt: z.target || '' })),
          custom_contents: item.fields.filter(x => (x.type === 'subfields' && x.id === 'customfields'))[0].fields.map(z => ({ id: z.id, target: z.target })),
        }];

      this.props.saveProducts(this.props.editLanguage, usedItems, 1)
    }
  }

  onExpandMetadata(id) {
    
  }

  onCollapsedMetadata(id) {
    
  }

  onExpandCollapsableFields = (type, id) => {
    if(type === 'metafields' && this.state.products.find(x => x.id == id).metafields_synchronized != true) {
      this.props.syncProductMetafields(id, this.props.editLanguage)
    }

    if(type === 'variant_metafields' && this.state.products.find(x => x.id == id).variant_metafields_synchronized != true) {
      this.props.syncProductVariantMetafields(id, this.props.editLanguage)
    }

    if(type === 'images' && this.state.products.find(x => x.id == id).images_synchronized != true) {
      this.props.syncProductImages(id, this.props.editLanguage)
    }
  }

  onSaveMetadata = (items, selectedFields, pinnedLanguage) => {
    let tags = []
    let types = []
    let vendors = []
    items.forEach(item => {
      if(item.id === 'tags') {
        item.fields.forEach(field => {
          tags.push({
            id: field.id,
            source: field.source,
            target: field.target
          })
        })
      } else if(item.id === 'types') {
        item.fields.forEach(field => {
          types.push({
            id: field.id,
            source: field.source,
            target: field.target
          })
        })
      } else if(item.id === 'vendors') {
        item.fields.forEach(field => {
          vendors.push({
            id: field.id,
            source: field.source,
            target: field.target
          })
        })
      }
    })

    this.props.saveMetadata(pinnedLanguage || this.props.editLanguage, tags, types, vendors)
  }

  onResaveAllMetadata = (itemId) => {
    const item = this.state.metadata.find(x => x.id == itemId);
    if(item) {
      let tags = []
      let types = []
      let vendors = []

      if(item.id === 'tags') {
        item.fields.forEach(field => {
          tags.push({
            id: field.id,
            source: field.source,
            target: field.target
          })
        })
      } else if(item.id === 'types') {
        item.fields.forEach(field => {
          types.push({
            id: field.id,
            source: field.source,
            target: field.target
          })
        })
      } else if(item.id === 'vendors') {
        item.fields.forEach(field => {
          vendors.push({
            id: field.id,
            source: field.source,
            target: field.target
          })
        })
      }

      this.props.saveMetadata(this.props.editLanguage, tags, types, vendors, 1)
    }
  }

  openNewCustomContentDialog = (itemId) => {
    const customContentPlainTextData = [];
    const product = this.state.products.find(x => x.id == itemId);

    product.fields.find(x => x.id == 'customfields').fields.forEach((custom_content) => {
      customContentPlainTextData.push(custom_content.source);
    })

    this.setState({addingNewCustomContent: true, addingNewCustomContentProductId: itemId, customContentPlainTextData: customContentPlainTextData})
  }

  closeNewCustomContentDialog = ()  => {
    this.setState({addingNewCustomContent: false, addingNewCustomContentProductId: null, customContentPlainTextData: []})
  }

  onSaveNewCustomContentDialog = (productId, items) => {
    const usedItems = [];
    items.forEach(item => {
      if(item.text != '') {
        usedItems.push({
          text: item.text
        })
      }
    })
    
    this.setState({addingNewCustomContent: false, addingNewCustomContentProductId: null});
    this.props.createProductCustomContents(productId, this.props.editLanguage, usedItems);
  }

  onDeleteCustomContent = productId => {
    return itemId => {
      this.props.deleteProductCustomContent(productId, itemId);
    }
  }


  onImport = (e) => {
    this.setState({forceOpenImportDialog: true}, () => {
      this.setState({forceOpenImportDialog: false});
    });   
    this.importEvent = e;
    this.setState({ optionsMenuAnchorEl: null });
  }

  onExport = (e) => {
    this.setState({forceOpenExportDialog: true}, () => {
      this.setState({forceOpenExportDialog: false});
    });   
  }

  onImportMetafields = (e) => {
    this.setState({ optionsMenuAnchorEl: null });
    
    const file = e.target.files[0];
    const fileType = file.name.substr(file.name.lastIndexOf('.') + 1).toLowerCase();
    if(fileType != 'mo' && fileType != 'csv') {
      return;
    }
    
    const formData = new FormData();
    formData.append('file', file);

    this.props.importProductMetafields(formData, fileType, this.props.editLanguage)
  }

  onExportMetafields = (e) => {
    /*
    this.setState({forceOpenExportDialog: true}, () => {
      this.setState({forceOpenExportDialog: false});
    });   
    */
    if(!this.props.products.export_po_download_url && !this.props.products.export_csv_download_url) {
      this.props.exportProductMetafields(this.props.editLanguage, () => {
        this.setState({forceOpenExportDialog: true}, () => {
          this.setState({forceOpenExportDialog: false});
        });
      });
    } else {
      //this.setState({showDownloadDialog: true})
      this.setState({forceOpenExportDialog: true}, () => {
        this.setState({forceOpenExportDialog: false});
      });   
    }
  }

  onResaveAll = (e) => {
    const usedItems = [];
    this.state.products.forEach(item => {
      usedItems.push(item.id)
    });
    this.props.resaveProducts(this.props.editLanguage, usedItems)
  }

  onResyncAll = (e) => {
    this.props.resyncProducts(this.props.editLanguage)
  }

  onCloseDownloadDialog = () => {
    //this.setState({showDownloadDialog: false})
  }

  onCloseImportCompleteDialog = () => {
    window.location.reload();
  }

  onBulkTranslateAll = () => {
    this.setState({showBulkDialog: false}, () => {
      this.setState({showBulkDialog: true});
    });
  }

  render() {
    const { t, classes } = this.props
    const targetLanguageCode = this.props.languages.languages.find(x => x.id == this.props.editLanguage) ? this.props.languages.languages.find(x => x.id == this.props.editLanguage).code : null;

    const hasProducts = this.props.products.products && this.props.products.products.length > 0;

    if(!hasProducts && (this.props.products.sync_products_pending === true || (this.props.products.error && this.props.products.error.level === 0))) {
      return <React.Fragment>
        <Typography variant="h4" gutterBottom component="h2">
          {t('pages.products.title')}
        </Typography>
        <Divider className="divider-white" />
        <ItemsListSkeleton rows="3" hideBottomToolbar/>
        <ItemsListSkeleton rows="10"/>
        <LoadingIndicator
          pending={this.props.products.sync_products_pending || this.props.products.sync_product_pending || this.props.products.save_products_pending || this.props.products.save_metadata_pending || this.props.products.export_products_pending || this.props.products.import_products_pending}
          progress={this.props.products.progress}
          error={this.props.products.error}
        />
      </React.Fragment>
    }

    return <React.Fragment>
      <Typography variant="h4" gutterBottom component="h2">
        {t('pages.products.title')}

        <OptionsMenu
          dataTour="page-options-menu"
          onImport={this.onImport}
          onExport={this.onExport}
          onImportMetafields={(this.props.langify_features && this.props.langify_features.find(x => x.name === 'import_export_metafields') && this.props.langify_features.find(x => x.name === 'import_export_metafields').is_enabled == true) ? this.onImportMetafields : null}
          onExportMetafields={(this.props.langify_features && this.props.langify_features.find(x => x.name === 'import_export_metafields') && this.props.langify_features.find(x => x.name === 'import_export_metafields').is_enabled == true) ? this.onExportMetafields : null}
          onResaveAll={this.onResaveAll}
          onResyncAll={this.onResyncAll}
          shopPlan={this.props.shopPlan}
          //onBulkTranslateAll={(this.props.langify_features && this.props.langify_features.find(x => x.name === 'auto_translation_bulk') && this.props.langify_features.find(x => x.name === 'auto_translation_bulk').is_enabled == true) ? this.onBulkTranslateAll : null}
        />

        <SolutionsArticleLink
          article="productTranslations"
          subject={t('pages.products.title')}
          placement="headingMenu"
        />
      </Typography>

      {this.state.addingNewCustomContent ? (
        <NewFlexItemList
          scope={this.state.addingNewCustomContentProductId}
          data={this.state.customContentPlainTextData}
          onSave={this.onSaveNewCustomContentDialog}
          onCancel={this.closeNewCustomContentDialog}
          isPending={false}
        />
      ) : (
        null
      )}

      <Divider className="divider-white" />

      <ItemsList
        type="products"
        virtualized={true}
        pagination={false}
        onExpand={(id) => {this.onExpandMetadata(id)}}
        onCollapsed={this.onCollapsedMetadata}
        isPending={
          this.props.products.save_metadata_pending
        }
        isSaving={
          this.props.products.save_metadata_pending
        }
        deletable={false}
        onSave={this.onSaveMetadata}
        onResaveAll={this.onResaveAllMetadata}
        data={this.state.metadata}
        isSticky={false}
        paginate={false}
        hideFilterbar={true}
        hideSorting={true}
        allowAutoTranslation={true}
        //error={this.props.products.error}
      />
      <ItemsList
        type="products"
        pagination={true}
        filterDisabled={this.props.products.sync_products_pending}
        syncProgress={this.props.products.sync_products_pending ? (typeof this.props.products.progress === 'number' ? this.props.products.progress : true) : undefined}
        syncedCount={this.props.products.sync_synced_count}
        syncTotalCount={this.props.products.sync_total_count}
        onExpand={(id) => {this.onExpandProduct(id)}}
        onCollapsed={this.onCollapsedProduct}
        isPending={
          this.props.products.sync_products_pending ||
          this.props.products.sync_product_pending ||
          this.props.products.sync_product_metafields_pending ||
          this.props.products.sync_product_variant_metafields_pending ||
          this.props.products.sync_product_images_pending ||
          this.props.products.create_product_custom_contents_pending ||
          this.props.products.delete_product_custom_content_pending ||
          this.props.products.save_products_pending ||
          this.props.products.export_products_pending ||
          this.props.products.import_products_pending
        }
        isSubfieldsPending={
          this.props.products.create_product_custom_contents_pending ||
          this.props.products.delete_product_custom_content_pending ||
          this.props.products.sync_product_images_pending ||
          this.props.products.sync_product_metafields_pending ||
          this.props.products.sync_product_variant_metafields_pending ||
          this.props.products.get_option_values_page_pending
        }
        isSubfieldsRemoving={
          this.props.products.delete_product_custom_content_pending
        }
        isSaving={
          this.props.products.save_products_pending
        }
        deletable={false}
        onSave={this.onSaveProduct}
        onResaveAll={this.onResaveAllProduct}
        data={this.state.products}
        onExpandCollapsableFields={this.onExpandCollapsableFields}
        allowAutoTranslation={true}
        error={this.props.products.error}
        errorLockCollapse={this.state.errorLockCollapse}
        saveErrors={this.props.products.saveErrors}
        emptyMessage={
          <EmptyView 
            title={'No products available'}
            bottom={<Button href={`https://${this.props.shopUrl}/admin/products`} variant="contained" color="primary">{t('system.createOneHere')}</Button>}
          />
        }

        // With the subfieldsPaginateFunc property, you can pass the redux action that should be invoked when a new page is choosen in the 
        // respective subfields section. The key is the id of the subfields element and the value would be the actual redux action
        subfieldsPaginateFunc={{

          variants: (itemId, page) => {
            this.props.getProductOptionValuesPaginated(itemId, this.props.editLanguage, page) }
        }}
      />
      <LoadingIndicator
        pending={this.props.products.sync_product_pending || this.props.products.save_products_pending || this.props.products.save_metadata_pending || this.props.products.sync_product_metafields_pending || this.props.products.sync_product_variant_metafields_pending || this.props.products.sync_product_images_pending || this.props.products.create_product_custom_contents_pending || this.props.products.delete_product_custom_content_pending || this.props.products.export_products_pending || this.props.products.import_products_pending}
        loadingType={(this.props.products.save_products_pending || this.props.products.save_metadata_pending) ? 'saving' : 'loading'}
        progress={this.props.products.progress}
        error={this.props.products.error}
        onErrorCancel={this.props.resetErrors}
        onErrorRetry={() => {
          this.setState({ errorLockCollapse: true }, () => {
            this.setState({ errorLockCollapse: false });
          });
        }}
      />

      {/*this.props.langify_features && this.props.langify_features.find(x => x.name === 'auto_translation_bulk') && this.props.langify_features.find(x => x.name === 'auto_translation_bulk').is_enabled === true && targetLanguageCode &&
        <BulkTranslations
          scope="products"
          targetLanguageCode={targetLanguageCode}
          open={this.state.showBulkDialog}
        />
      */}

      <ExportImportDialogs
        showDownloadDialog={this.state.showDownloadDialog}
        showImportCompleteDialog={this.state.showImportCompleteDialog}
        imported_entries={this.props.products.imported_entries}
        export_po_download_url={this.props.products.export_po_download_url}
        export_csv_download_url={this.props.products.export_csv_download_url}
        export_advanced_csv_download_url={this.props.products.export_advanced_csv_download_url}
        forceOpenExportDialog={this.state.forceOpenExportDialog}
        forceOpenImportDialog={this.state.forceOpenImportDialog}
        exportFunc={(options) => { this.props.exportProducts(this.props.editLanguage, options) }}
        exportMetafieldsFunc={(options) => { this.props.exportProductMetafields(this.props.editLanguage, options) }}
        importFunc={(formData, fileType, options) => { this.props.importProducts(formData, fileType, options, this.props.editLanguage) }}
        syncFunc={() => { this.props.syncProducts(this.props.editLanguage)}}
        clearFunc={this.props.clearExportUrls}
        pending={this.props.products.export_products_pending}
        scope={'products'}
        additionalFields={['custom_contents', 'product_tags', 'product_types', 'product_vendors', 'with_BOM']}
      />
    </React.Fragment> 
  }
}

const mapStateToProps = ({ products, shop, languages }) => ({
  products: products,
  editLanguage: shop.shop.edit_language,
  shopPlan: shop.shop.charge.name,
  shop_version: shop.shop.version,
  shopUrl: shop.shop.url,
  langify_features: shop.shop.langify_features,
  languages: languages,
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      syncProducts,
      resyncProducts,
      syncProduct,
      saveProducts,
      resaveProducts,
      saveMetadata,
      syncProductMetafields,
      syncProductVariantMetafields,
      syncProductImages,
      createProductCustomContents,
      deleteProductCustomContent,
      exportProducts,
      importProducts,
      exportProductMetafields,
      importProductMetafields,
      clearExportUrls,
      resetErrors,
      getProductOptionValuesPaginated
    },
    dispatch
  )

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(Products)))